module.exports = __webpack_public_path__ + "img/3.6e33260a.jpg";